export const VAULTQUEST_APP_STORE_ID = "6807077291";
